import styled from 'styled-components';
import color from '../../../../config/colors.json';

export const Question = styled.span`
    display: flex;
    justify-content: flex-start;
    font-family: Poppins, Helvetica, Arial, sans-serif;
    font-size: 18px;
    color: ${color.darkGrey};
    font-weight: 600;
`;

export const Title = styled.span`
    font-family: Poppins, Helvetica, Arial, sans-serif;
    font-size: 31px;
    color: ${color.sofDark};
    font-weight: 500;
    margin-bottom: 35px;
`;

export const Subtitle = styled.span`
    font-family: Poppins, Helvetica, Arial, sans-serif;
    font-size: 22px;
    color: ${color.lightGrey21};
    font-weight: 300;
    margin-top: ${({ marginTop }) => (marginTop || '0')};
    margin-bottom: ${({ marginBottom }) => (marginBottom || '32px')};
`;
